import { buildPath, getParamsMap } from './utils/params';

export const convertToURl = (template: string, params?: object) => {
  const [method, path] = template.split(' ');
  const paramsMap = getParamsMap(params);
  const urlPath = buildPath(path, paramsMap);
  let url = `https://${process.env.REACT_APP_API_HOST}${urlPath}`;
  if (method === 'GET' && paramsMap.size > 0) {
    const queryParams = new URLSearchParams(
      Object.fromEntries(paramsMap)
    ).toString();
    url += '?' + queryParams;
  }
  return { method, url, urlPath };
};
